import { render, staticRenderFns } from "./GreenOperationHistory.vue?vue&type=template&id=61d8383e&scoped=true&"
import script from "./GreenOperationHistory.vue?vue&type=script&lang=js&"
export * from "./GreenOperationHistory.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationHistory.vue?vue&type=style&index=0&id=61d8383e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8383e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d8383e')) {
      api.createRecord('61d8383e', component.options)
    } else {
      api.reload('61d8383e', component.options)
    }
    module.hot.accept("./GreenOperationHistory.vue?vue&type=template&id=61d8383e&scoped=true&", function () {
      api.rerender('61d8383e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/letters/GreenOperationHistory.vue"
export default component.exports